import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	pathBeforeTokenExpire: '',
};

export const GeneralSlice = createSlice({
	name: 'UI',
	initialState,
	reducers: {
		setPath: (state, action) => {
			state.pathBeforeTokenExpire = action.payload;
		},
	},
});

export const { setPath } = GeneralSlice.actions;

export default GeneralSlice.reducer;
